import { BaseResource } from 'e100-data-providers';
import { TRestProvider } from 'dataSources/types/restProvider';
import { StationsByEventResponse, EventsResponse } from './types';

export * from './types';

class Events extends BaseResource {
  path: string = '';

  constructor(provider: TRestProvider) {
    super(provider);
    this.path = 'events';
  }

  getEvents(): EventsResponse {
    return this.getItems();
  }

  getEventById(id: string): StationsByEventResponse {
    return this.getChildResource(`stations?specialEventId=${id}`).getItems();
  }
}

export default Events;
